import { EntityType } from '../../models/InvestmentEntity';
import InvestmentEntityContact, { ContactRole } from '../../models/InvestmentEntityContact';
import { getContactRequirements } from '../../utils/contactRequirements';

export function countContactsByRole(
  associatedContacts: InvestmentEntityContact[],
): Partial<Record<ContactRole, number>> {
  const roleCounts: Partial<Record<ContactRole, number>> = {};

  associatedContacts.forEach((contact) => {
    roleCounts[contact.role] = (roleCounts[contact.role] || 0) + 1;
  });

  return roleCounts;
}

export function getContactValidationErrors(
  associatedContacts: InvestmentEntityContact[],
): string[] {
  const roleCounts = countContactsByRole(associatedContacts);
  const errors: string[] = [];

  if ((roleCounts.OWNER || 0) === 0) {
    errors.push('Consider adding at least one owner contact for this entity');
  }

  return errors;
}

export function getAvailableContactRoles(
  entityType: EntityType,
  associatedContacts: InvestmentEntityContact[],
): ContactRole[] {
  const contactRequirements = getContactRequirements(entityType);
  const roleCounts = countContactsByRole(associatedContacts);

  return contactRequirements
    .filter((req) => !req.maxCount || (roleCounts[req.role] || 0) < req.maxCount)
    .map((req) => req.role);
}

export function getContactRoleDescription(entityType: EntityType, role: ContactRole): string {
  const contactRequirements = getContactRequirements(entityType);
  const requirement = contactRequirements.find((req) => req.role === role);
  return requirement?.description || role.toLowerCase().replace('_', ' ');
}

export function canCompleteWithoutAssociatedContacts(entityType: EntityType): boolean {
  const contactRequirements = getContactRequirements(entityType);
  return !contactRequirements.some((req) => req.required);
}
